<template>
  <div class="pm70">
    <!-- <img src="../../assets/img/banner.jpg" class="banner w100 cz" /> -->
    <div class="kjnjsfoer pd pt20">
      <div style="display: flex; justify-content: space-between;">
        <p class="fz16 z3">参观日期</p>
        <p class="fz16" style="color:red;">周一闭馆（法定节假日除外）</p>
      </div>
      <div class="row">
        <div
          class="kjmmjknmxer cen mr15"
          v-for="(date, idx) in sltDates"
          :key="date.date"
          :class="{
            act: orderInput.travelDate === date.date,
            disabled: date.disable,
          }"
          @click="dateChanged(idx)"
        >
          <p class="fz12 z9 dfgdt">{{ date.text }}</p>
          <div class="cen btm z9 fz14">
            {{ date.disable ? "不可订" : date.date.substr(5) }}
          </div>
        </div>
        <div class="col">
          <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
            <p class="fz12 z9 dfgdt">更多</p>
            <div class="cen btm zts fz16">
              <i class="f_i gengdder"></i>
            </div>
          </div>
        </div>
      </div>
      <p class="mt15 fz16">请选择票类</p>
      <van-grid
        v-if="
          ticketTypesInfo.ticketTypes && ticketTypesInfo.ticketTypes.length > 0
        "
        :border="false"
        :column-num="1"
        class="ticket-grid"
      >
        <van-grid-item
          v-for="ticket in ticketTypesInfo.ticketTypes"
          :key="ticket.id"
          :name="ticket.id"
        >
          <div
            class="row"
            :class="[
              ticket.disabled || wxLastBookTime ? 'acb' : '',
              orderInput.ticketTypeId == ticket.id ? 'act' : '',
            ]"
            @click="ticketTypeChange(ticket)"
          >
            <div class="col pl15 fz14">
              {{ ticket.name }}
            </div>
            <div class="pl5 pr5 z8 fz12 ticket-grid-price">
              ¥{{ ticket.price.toFixed(2) }}
            </div>
            <div class="ticket-grid-slt">
              <i class="f_i gounmxer" v-if="!ticket.disabled"></i>
              <div v-else class="kjnmkxerse">不可预订</div>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <p class="mt15 fz16">
        参观时段<span class="z9 fz12"> (在该时段入场参观)</span>
      </p>
      <van-grid
        v-if="
          !wxLastBookTime &&
          ticketTypesInfo.ticketTypes &&
          ticketTypesInfo.ticketTypes.length > 0
        "
        :border="false"
        :column-num="1"
      >
        <van-grid-item
          v-for="tt in ticketTypesInfo.ticketTypes"
          :key="tt.id"
          :name="tt.id"
        >
          <van-grid
            v-if="
              !tt.disable &&
              tt.id == orderInput.ticketTypeId &&
              tt.changCis &&
              tt.changCis.length > 0
            "
            :border="false"
            :column-num="2"
          >
            <van-grid-item
              v-for="changCi in tt.changCis"
              :key="changCi.id"
              :name="changCi.id"
            >
              <div
                class="fgdrtwerab"
                :class="[orderInput.changCiId == changCi.id ? 'act' : '']"
                @click="changCiChange(changCi)"
              >
                <p class="fz17 z6">
                  {{ changCi.stime }}-{{ changCi.etime }}
                </p>
                <p class="zts fz12">
                  {{ "(余票:" + changCi.surplusNum + ")" }}
                </p>
              </div>
            </van-grid-item>
          </van-grid>
        </van-grid-item>
      </van-grid>
      <p class="mt15 fz16">参观人信息</p>
      <div class="mt15 row mb10">
        <p class="col fz14">参观人数</p>
        <van-stepper
          async-change
          :value="adultQuantity"
          :defaultValue="1"
          :min="minBuyQuantity"
          :max="maxAdultQuantity"
          @change="onAdultQuantity"
          integer
        />
      </div>
      <div>
        <div class="sdfsdtywer">
          <div v-for="(adult, index) in orderInput.adults" :key="index">
            <van-cell-group>
              <van-field
                ref="adultName"
                class="adultName"
                label="姓名"
                :maxlength="30"
                placeholder="必填，输入证件上的姓名"
                v-model="adult.name.value"
                :error="adult.name.error"
                clearable
              />
              <van-cell
                is-link
                title="证件类型"
                :value="adult.certTypeName || '请选择'"
                @click="onShowCertType(adult)"
                :value-class="adult.certTypeId ? 'z3' : ''"
              />
              <van-field
                v-if="adult.certTypeId == 5"
                clickable
                :label="adult.certNo.label"
                ref="certNo"
                class="certNo"
                maxlength="18"
                :placeholder="adult.certNo.placeholder"
                v-model="adult.certNo.value"
                :error="adult.certNo.error"
                clearable
                @focus="onCertNoFocus(index)"
                @touchstart.native.stop="onShowNumberKeyboard(index)"
              />
              <van-field
                v-else
                ref="certNo"
                :label="adult.certNo.label"
                :error="adult.certNo.error"
                v-model="adult.certNo.value"
                :placeholder="adult.certNo.placeholder"
                clearable
              />
            </van-cell-group>
          </div>
        </div>
      </div>
    </div>
    <p class="mt15 fz16 pm10 pd">联系人信息</p>
    <van-cell-group>
      <van-field
        ref="mobile"
        label="手机号码"
        :maxlength="11"
        placeholder="必填，请输入联系人手机号码"
        type="tel"
        v-model="orderInput.contact.mobile"
        :error="orderInput.contact.error"
        clearable
      ></van-field>
    </van-cell-group>
    <custom-submit-bar :totalMoney="orderInput.totalMoney" :disabled="!canSubmit" @onSubmit="onSubmit" />
    <div v-for="(adult, index) in orderInput.adults" :key="index">
      <van-number-keyboard
        safe-area-inset-bottom
        theme="custom"
        class=""
        :title="
          adult.certNo.value
            ? '身份证：' + adult.certNo.value
            : '请输入' +
              (adult.name.value ? adult.name.value + '的' : '') +
              '身份证号码'
        "
        v-model="adult.certNo.value"
        :show="showNumberKeyboards[index].show"
        :maxlength="18"
        extra-key="X"
        close-button-text="完成"
        @blur="onBlurNumberKeyboard(index)"
      />
    </div>
    <van-action-sheet
      v-model="showCertType"
      :actions="certTypes"
      @select="onCertTypeSelect"
    />
    <van-calendar
      v-model="showDateTimePicker"
      @confirm="confirmMoreDate"
      color="#810102"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector.vue";
import DateField from "@/components/DateField.vue";
import ticketTypeService from "@/services/ticketTypeService";
import CustomSubmitBar from "@/components/CustomSubmitBar.vue";
import IdcardField from "@/components/IdCardField.vue";
import PickerField from "./../../components/PickerField.vue";
import moment from "moment";
import validate from "@/utils/validator.js";
import dateHelper from "@/utils/dateHelper.js";
import { mapState, mapMutations } from "vuex";
import appConsts from "@/store/consts.js";
import orderService from "@/services/orderService";
import scenicService from "./../../services/scenicService.js";
import commonService from "./../../services/commonService.js";
import Vue from "vue";

function Tourist() {
  this.type = "成人";
  this.name = {
    value: "",
    error: false,
    errorMessage: "",
  };
  this.certTypeId = 5;
  this.certTypeName = "二代身份证";
  this.certNo = {
    value: "",
    error: false,
    errorMessage: "",
    placeholder: "必填，请输入证件号码",
    label: "证件号码",
  };
  this.birthday = "";
}

export default {
  name: "buyticket",
  components: {
    DateSelector,
    DateField,
    CustomSubmitBar,
    IdcardField,
    PickerField,
  },
  props: {
    publicSaleFlag: {
      type: String,
      default: "true"
    }
  },
  data() {
    return {
      loading: false,
      canSubmit: true,
      sltDates: [],
      ticketTypesInfo: { dates: [], ticketTypes: [] },
      orderInput: new orderService.CreateOrderInput(),
      changCiSurplusNum: 0,
      minBuyQuantity: 1,
      adultQuantity: 0,
      isKeyboardPopup: false,
      certTypes: [],
      showCertType: false,
      wxLastBookTime: "",
      showDateTimePicker: false,
      currentAdult: {},
      showNumberKeyboards: [],
      payTitle: ""
    };
  },
  computed: {
    maxAdultQuantity() {
      let maxQuantity = this.orderInput.adultQuantity == 1 ? 2 : this.orderInput.adultQuantity;
      let errorMsg = this.validDateChangCi();
      if (!errorMsg) {
        maxQuantity = 10;
        const tt = this.getSelectTicketType();
        if(tt&&tt.groundChangCis&&tt.groundChangCis.length>0) {
          let changciFlag = false;
          tt.groundChangCis.forEach(g=>{
            if(g.changCiId>0&& g.changCiDtos&& g.changCiDtos.length>0){
              const cc = g.changCiDtos.find(q=>q.id==g.changCiId);
              if(cc) {
                if(!changciFlag) {
                  maxQuantity = cc.surplusNum;
                  changciFlag = true;
                } else if(maxQuantity>cc.surplusNum) {
                  maxQuantity = cc.surplusNum;
                }
              }
            }
          });
        }
      }

      return maxQuantity;
    },
    minDate() {
      let date = this.ticketTypesInfo.dates.filter((d) => !d.disable)[0];
      if (date) {
        return new Date(date.date);
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    maxDate() {
      for(let i=this.ticketTypesInfo.dates.length-1;i>0;i--){
        const td = this.ticketTypesInfo.dates[i];
        if(!td.disabled){
          return new Date(td.date);
        }
      }

      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    ...mapState({
      member: (state) => state.memberModule.member,
    }),
  },
  watch: {
    "orderInput.travelDate": async function (newVal) {
      try {
        this.loading = true;
        this.getWxLastBookTime();
        this.ticketTypesInfo.ticketTypes = [];
        const tmpInfo = await ticketTypeService.getWechatTicketTypeInfoAsync({
          ticketsOnly: true,
          saleDate: newVal,
        });
        if (tmpInfo && tmpInfo.ticketTypes && tmpInfo.ticketTypes.length > 0) {
          this.ticketTypesInfo.ticketTypes = tmpInfo.ticketTypes;
          this.orderInput.ticketTypeId = "";
          this.setDefaultSlt();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.ticketTypeId": async function (newVal) {
      try {
        this.loading = true;
        if (newVal) {
          this.resetTotalMoney();
          await this.getChangCis();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.changCiId": function (newVal) {
      try {
        this.loading = true;
        if (newVal) {
          const tt = this.getSelectTicketType();
          if(tt&&!tt.disabled){
            const cc= tt.changCis.find(q=>q.id == newVal);
            if (cc) {
              this.changCiSurplusNum = cc.surplusNum;
            }
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.adultQuantity": function (newVal, oldVal) {
      try {
        this.loading = true;
        this.resetTotalMoney();
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let adult = new Tourist();
            adult.type = "成人";
            this.orderInput.adults.push(adult);
            this.showNumberKeyboards.push({ show: false });
          }
        } else {
          if (this.orderInput.adults.length + diff > 0) {
            this.orderInput.adults.length += diff;
            this.showNumberKeyboards.length += diff;
          } else {
            this.orderInput.adults.length = 0;
            this.showNumberKeyboards.length = 0;
          }
        }
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    this.ticketTypesInfo = await ticketTypeService.getWechatTicketTypeInfoAsync(
      { ticketsOnly: true, needSaleDateFlag: true }
    );

    this.getWxLastBookTime();
    if(this.ticketTypesInfo&&this.ticketTypesInfo.dates&&this.ticketTypesInfo.dates.length>0){
      this.sltDates = this.ticketTypesInfo.dates.slice(0, 3);
    }
    this.setDefaultSlt();

    await this.getCertTypes();

    this.orderInput.adultQuantity = 1;
  },
  mounted() {
    let clientHeight = document.documentElement.clientHeight;
    let vm = this;
    window.onresize = function () {
      let nowClientHeight = document.documentElement.clientHeight;
      vm.isKeyboardPopup = clientHeight > nowClientHeight;
      if (vm.isKeyboardPopup) {
        let top = 0;
        let element = document.activeElement;
        while (element) {
          top += element.offsetTop;

          element = element.offsetParent;
        }
        window.scrollTo(0, top - 100);
      }
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    getWxLastBookTime() {
      if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
        scenicService.validExceedWxLastBookTime().then((wxLastBookTime) => {
          this.wxLastBookTime = wxLastBookTime;
        });
      }
    },
    setDefaultSlt() {
      if (!this.orderInput.travelDate && this.sltDates) {
        this.orderInput.travelDate = this.sltDates.filter(
          (d) => !d.disable
        )[0].date;
      }
      if (!this.orderInput.ticketTypeId && this.ticketTypesInfo.ticketTypes) {
        const tt = this.ticketTypesInfo.ticketTypes.filter(
          (d) => !d.disable
        )[0];
        if(tt) {
          this.orderInput.ticketTypeId = tt.id;
          this.payTitle = tt.name;
        }
      }
      // if(this.ticketTypesInfo.ticketTypes&&this.ticketTypesInfo.ticketTypes.length>0){
      //   this.orderInput.changCiId = this.ticketTypesInfo.ticketTypes[0].changCis.filter(
      //     (d) => !d.disable
      //   )[0].id;
      // }

      this.resetTotalMoney();
    },
    dateChanged(index) {
      try {
        let date = this.ticketTypesInfo.dates[index];
        if (date.disable) {
          return;
        }
        this.orderInput.travelDate = date.date;

        this.loading = true;
      } finally {
        this.loading = false;
      }
    },
    ticketTypeChange(tt) {
      this.minBuyQuantity = this.adultQuantity = 1;
      if (!tt.disabled) {
        this.orderInput.ticketTypeId = tt.id;
        this.minBuyQuantity = tt.minBuyNum;
      }
    },
    getSelectTicketType() {
      return this.ticketTypesInfo.ticketTypes.find(
        (q) => q.id == this.orderInput.ticketTypeId
      );
    },
    async getChangCis() {
      if (!this.orderInput.ticketTypeId) {
        return;
      }
      let tt = this.getSelectTicketType();
      if (!tt || tt.disabled) {
        return;
      }
      tt.changCis = [];
      this.payTitle = tt.name;

      this.getWxLastBookTime();
      if (this.wxLastBookTime) {
        return;
      }

      tt.changCis = await ticketTypeService.getWechatGroundChangCisAsync({
        saleDate: this.orderInput.travelDate,
        ticketTypeId: this.orderInput.ticketTypeId,
      });
    },
    changCiChange(event) {
      if(event.surplusNum<=0) {
        this.$toast("该时段没有余票，请选择其它时段");
        return;
      }
      this.orderInput.changCiId = event.id;
    },
    validDateChangCi() {
      const tt = this.getSelectTicketType();
      if (!tt||tt.disabled) {
        return "请选择票类";
      }
      if (!this.orderInput.changCiId) {
        return "请选择参观时段";
      }

      return "";
    },
    onAdultQuantity(event) {
      let errorMsg = this.validDateChangCi();
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.maxAdultQuantity) {
          minNum = this.maxAdultQuantity;
        } else {
          minNum = event;
        }
        errorMsg += this.validChangCiSurplus(minNum);
      }
      if (errorMsg) {
        this.$toast(errorMsg);
      } else {
        this.orderInput.adultQuantity = minNum;
        this.adultQuantity = minNum;
      }
    },
    resetTotalMoney() {
      const tt = this.getSelectTicketType();
      if (tt&&!tt.disabled) {
        this.orderInput.totalMoney = tt.price * this.orderInput.adultQuantity;
      } else {
        this.orderInput.totalMoney=0;
      }
    },
    onBlurNumberKeyboard(index) {
      try {
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });
        let result = validate([
          {
            value: this.orderInput.adults[index].certNo.value,
            name: this.orderInput.adults[index].name.value + "证件号码",
            rules: certRules,
          },
        ]);
        Vue.set(this.orderInput.adults[index].certNo, "error", !result.success);
        Vue.set(
          this.orderInput.adults[index].certNo,
          "errorMessage",
          result.message
        );
        if (!result.success) {
          this.$toast(result.message);
        }
      } finally {
        this.showNumberKeyboards[index].show = false;
      }
    },
    onCertNoFocus(index) {
      if (this.showNumberKeyboards[index].show) {
        document.activeElement.blur();
      }
    },
    onShowNumberKeyboard(val) {
      for (var i = 0; i < this.showNumberKeyboards.length; i++) {
        this.showNumberKeyboards[i].show = false;
      }
      this.showNumberKeyboards[val].show = true;
      document.activeElement.blur();
    },
    onShowCertType(adult) {
      this.currentAdult = adult;
      this.showCertType = true;
    },
    onCertTypeSelect(item) {
      this.currentAdult.certTypeId = item.value;
      this.currentAdult.certTypeName = item.name;
      this.showCertType = false;
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.orderInput.travelDate = value.format("YYYY-MM-DD");
      if (this.sltDates.filter((d) => d.date == this.orderInput.travelDate).length <= 0) {
        this.sltDates = this.sltDates.slice(0, 2);
        this.sltDates.push({date:this.orderInput.travelDate,text: value.format("ddd"),disable: false});
      }
    },
    cancelMoreDate() {
      this.showDateTimePicker = false;
    },
    async getCertTypes() {
      const certTypes = await commonService.getCertTypeComboboxItemsAsync();
      this.certTypes = certTypes.map((c) => {
        return {
          value: c.value,
          name: c.displayText,
          disabled: c.disabled,
        };
      });
    },
    validDateInput() {
      let errorMsg = this.validDateChangCi();
      if (!errorMsg) {
        if (this.orderInput.adults.length < 1) {
          errorMsg += "请添加参观人信息";
        }
      }
      if (errorMsg) {
        this.$toast(errorMsg);
        return false;
      } else {
        if (this.orderInput.adults.length > 0) {
          for (let i = 0; i < this.orderInput.adults.length; i++) {
            let adult = this.orderInput.adults[i];
            let result = validate([
              {
                value: adult.name.value,
                name: "姓名",
                rules: [
                  {
                    rule: "required",
                  },
                ],
              },
            ]);
            Vue.set(adult.name, "error", !result.success);
            Vue.set(adult.name, "errorMessage", result.message);
            if (!result.success) {
              this.$refs.adultName[i].$refs.input.focus();
              this.$toast(result.message);
              return false;
            }

            let certRules = [
              {
                rule: "required",
              },
            ];
            if (adult.certTypeId == 5) {
              certRules.push({
                rule: "isIdCard",
              });
            }
            result = validate([
              {
                value: adult.certNo.value,
                name: "证件号码",
                rules: certRules,
              },
            ]);
            Vue.set(adult.certNo, "error", !result.success);
            Vue.set(adult.certNo, "errorMessage", result.message);
            if (!result.success) {
              this.$toast(result.message);
              return false;
            }
          }
        }

        // let adultQuantity = this.orderInput.adultQuantity;
        // if (this.member.hasElectronicMemberCard) {
        //   adultQuantity++;
        // }

        let result = validate([
          {
            value: this.orderInput.contact.mobile,
            name: "手机号",
            rules: [{ rule: "required" }, { rule: "isMobile" }],
          },
        ]);
        Vue.set(this.orderInput.contact, "error", !result.success);
        Vue.set(this.orderInput.contact, "errorMessage", result.message);
        if (!result.success) {
          this.$refs.mobile.$refs.input.focus();
          this.$toast(result.message);
          return false;
        }
      }
      return true;
    },
    async onSubmit() {
      if (!this.validDateInput()) {
        return;
      }

      try {
        const input = {
          travelDate: this.orderInput.travelDate,
          ticketTypeId: this.orderInput.ticketTypeId,
          changCiId: this.orderInput.changCiId,
          quantity: this.orderInput.adultQuantity,
          tourists: this.orderInput.adults.map((t) => {
            return {
              type: t.type,
              name: t.name.value,
              certTypeId: t.certTypeId,
              certNo: t.certNo.value
            };
          }),
          contactMobile: this.orderInput.contact.mobile
        };

        this.loading = true;
        this.canSubmit = false;
        const res = await orderService.createSaleOrderAsync(input);
        if (res.shouldPay) {
          this.$router.push({
            name: "wxjspay",
            params: { listNo: res.listNo , payTitle: this.payTitle}
          });
        } else {
          this.$router.push({
            name: "orderinfo",
            params: { listNo: res.listNo }
          });
        }
      } catch (err) {
        return;
      } finally {
        this.loading = false;
        this.canSubmit = true;
      }
    },
    validChangCiSurplus(quantity) {
      const tt = this.getSelectTicketType();
      if(tt&&!tt.disabled&&tt.groundChangCis) {
        for(let i=0;i<tt.groundChangCis.length;i++){
          const gr = tt.groundChangCis[i];
          if(gr.changCiDtos && gr.changCiDtos.length>0) {
            const cc = gr.changCiDtos.find(q=> q.id==gr.changCiId);
            if(cc&&cc.surplusNum<quantity) {
              return `${gr.groundName}[${cc.stime}-${cc.etime}]剩余数量不足。`;
            }
          }
        }
      }

      return "";
    },
    ...mapMutations([appConsts.setShowNavbar])
  },
};
</script>

<style lang="scss">
.ticket-grid {
  margin-right: -10px;
  .row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border: 1px solid #b3b3b3;
    background-color: #fff;
    height: 34px;
    width: 100%;
    color: #333;
    border-radius: 4px;
    margin-top: 10px;
    overflow: hidden;
    .ticket-grid-price {
      width: 80px;
      font-weight: bold;
    }
    .ticket-grid-slt {
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .act {
    border-color: #810102;
    background-color: #f8e4e5;
    .ticket-grid-slt {
      background: #810102;
    }
  }
}
.van-grid-item__content {
  padding: 0px 10px 0px 0px;
}
.van-grid-item__content--center {
  align-items: unset;
}
.tourist {
  &-tips {
    font-size: 12px;
    margin: 0 15px;
    margin-bottom: 10px;
    padding: 5px 5px;
    background-color: #f5f9f8;
    border-radius: 3px;

    span {
      padding-left: 5px;
    }
  }
}
.van-number-keyboard {
  padding-bottom: 68px!important;
}
.van-key--blue {
  background-color: #810102;
  color: #fff;
}
.van-number-keyboard__title {
  font-size: 18px;
}
.van-cell__value {
  color: #969799;
}
.sub-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .sub-bar-pay {
    width: 36%;
  }
}
</style>
